import { cn } from '../cn.js';

export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  'aria-label'?: string;
  className?: string;
}

/** An accessible on/off toggle switch. */
export function Switch({
  checked,
  onChange,
  disabled = false,
  className,
  ...aria
}: SwitchProps): JSX.Element {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={aria['aria-label']}
      disabled={disabled}
      className={cn('as-switch', checked && 'as-switch--on', className)}
      onClick={() => onChange(!checked)}
    >
      <span className="as-switch__thumb" />
    </button>
  );
}
